<style lang="scss">
  .post-type-tab {
    .ivu-tabs-ink-bar {
      background-color: var(--link-active-color) !important;
    }
    .ivu-tabs-tab-active {
      background-color: transparent !important;
    }
  }
  .profile-view-template .ivu-badge-count {
    right:5px;
    top:-5px;
  }
  .profile-view-template .tab-no-height .ivu-tabs-nav-wrap  {
    height: 0px;
  }
  .claimProfile .ivu-modal {
  top: 30px;
  }
  .claimProfile .ivu-modal-content {
    overflow: hidden;
  }
  .claimProfile .ivu-modal-header {
    padding: 0;
  }
  .claimProfile .ivu-modal-body {
    padding: 5px;
    background-color: white;
  }
  .claimProfile .ivu-modal-footer {
    border-top: 1px solid #e9eaec;
    padding: 5px 10px;
  }
  .claimProfile .ivu-modal-close .ivu-icon-ios-close-empty {
    top: -6px;
    color: #fff;
  }
  .help-modal .ivu-modal-body > div {
    height: inherit !important;
    max-height: 40vh;
  }
  .upload-button, .post-button {
    display: flex;
    justify-content: center;
    width: 49%;
    margin: 2px 0;
    span {
      font-size: 16px;
    }
  }
</style>

<style scoped>
  .colored-ui-twitter {
    background: #1DA1F3;
  }
  .colored-ui-facebook {
    background: #3B5999;
  }
  .colored-ui-website {
    background: #3B5999;
  }
  .colored-ui-instagram {
    background: linear-gradient(to bottom left, #AD39B4, #DA3370, #F6C25C);
  }
  .colored-ui-linkedin {
    background: #007BB6;
  }

  .btn-default {
    width:40px;
    height: 40px;
    margin-left:5px;
  }
  .img-bookmark {
    margin-left: -6px;
    width: 20px;
    height: 16px;
    margin-top: 5px;

    /* filter: sepia(100%) hue-rotate(190deg) saturate(500%);
    -webkit-filter: sepia(100%) hue-rotate(190deg) saturate(500%); */
  }
  .img-report {
    margin-left: -6px;
    width: 18px;
    height: 18px;
    margin-top: 5px;
  }
  .spin-icon-load{
    animation: ani-spin 1s linear infinite;
  }
  @keyframes ani-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .spin{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
  .badge {
    width: 42px;
    height: 42px;
    background: #eee;
    border-radius: 6px;
    display: inline-block;
  }

  .profile-view-template .profile-holder{
    margin: 0px !important;
    margin-top: 10px !important;
  }

  .avatar-box {
    position:absolute;
    top:0;
    right:1;
    left:1;
    bottom:0;
    width:calc(100% - 10px);
    height:100%;
    border-radius:10px;
    /* padding-left:5px;
    padding-right:5px */
    cursor: pointer;
  }

  .profile-info {
    display: inline-block;
    position: absolute;
    margin-left: 15px;
    overflow-y: hidden;
    max-height: 112px;
  }

  .profile-header-loader{
    display: flex;
  }

  .profile-header-loader > .image{
    min-width: 110px;
    border-radius: 20px;
    height: 110px;
    background: #eaeaea;
  }

  .profile-info-loader > .badges{
    display: flex;
    margin-top: 10px;
    justify-content: space-around;
  }

  .profile-header-loader > .profile-info-loader{
    margin-left: 15px;
    width: 100%;
  }

  .profile-extras-loader {
    display:block;
  }

  .name {
    width: 120px;
    height: 20px;
    background: #eaeaea;
    border-radius: 4px;
  }
  .badge-content {
    border-radius:100%;
    margin-right:6px;
    width:35px;
    height:35px;
    cursor: pointer;
  }

  .badge-content-loading {
    cursor: unset;
    background: linear-gradient(-45deg, #dadada, #c0c0c0, #ffffff);
    background-size: 400% 400%;
    -webkit-animation: Gradient 3s ease infinite;
    -moz-animation: Gradient 3s ease infinite;
    animation: Gradient 3s ease infinite;
  }


@-moz-keyframes Gradient {
	0% {
		background-position: 0% 50%
	}
	50% {
		background-position: 100% 50%
	}
	100% {
		background-position: 0% 50%
	}
}

@keyframes Gradient {
	0% {
		background-position: 0% 50%
	}
	50% {
		background-position: 100% 50%
	}
	100% {
		background-position: 0% 50%
	}
}

  .badge-loader{
    width: 50px;
    height: 50px;
    background: #eaeaea;
    border-radius: 50%;
  }

  .profile-menu {
    height: 45px;
    line-height: 45px;
    font-size: 1em;
  }

  .country-flag {
    width: 32px;
    height: 32px;
    position: absolute;
    border:3px solid #fff;
    top: -6px;
    left: -2px;
    margin-right: -25px;
    border-radius: 50%;
  }

  .social-links-style > span {
    margin-left:3px;
    display:inline-block;
  }

  .honorary-badge {
    position: absolute;
    top:-5px;
    left:calc(100% - 32px);
  }
</style>

<template>
  <app-layout class="profile-view-template">
      <div>
        <Affix :offset-top="offsetNo" @on-change="change">
            <div class="stickyTab" v-if="stickTabs && !isHonorary" style="background:rgb(240, 240, 240)">
              <transition name="mfade">
                <Tabs :animated="false" @on-click="onTabClick" v-model="tabName">
                  <TabPane :label="labelMe" name="me"></TabPane>
                  <TabPane v-if="!isBroadcast" :label="labelTimeline" name="timeline"></TabPane>
                  <TabPane v-if="!isBroadcast" :label="isCurrentUser ? 'My Team' : 'Team'" name="team"></TabPane>
                  <!-- <TabPane label="About" name="about"></TabPane> -->
                </Tabs>
              </transition>
            </div>
        </Affix>
        <Tabs :animated="false" @on-click="onTabClick" v-model="tabName">
          <TabPane :label="labelMe" name="me" :disabled="profileLoader">
            <Card class="profile-holder" shadow :padding="0" :style="{borderRadius: '0'}" style="margin:15px;padding: 15px">
              <Row :gutter="10" type="flex" align="top" v-if="profile && !profileLoader">
                <i-col :span="9" style="position:relative" v-if="false">
                  <div ref="UA"  style="overflow:hidden;width:100%;padding-top:100%;;display:block;border-radius:10px">
                    <img class="avatar-box" @click="showVuerSingle($event,'imgViewer2',true)" v-on:load="onloadAvatar" ref="imgViewer2" :src="('avatar' in profile && profile.avatar) ? userDisplayImage(profile): profilePlaceholder" alt=" "/>
                  </div>
                  <!-- <router-link v-if='country.prescribed_by == profile.id && country.careplan.title != "Philippines"' tag="img" :to="'/resources/' + country.careplan.id" class='country-flag' :src="country | getCountryImage" width="32" height="32" alt=""/> -->
                  <!-- <router-link v-if='honoraryBadge.length != 0' :to="route(honoraryBadge)">
                    <Avatar v-if='!isHonoraryLoading && honoraryBadge' class='honorary-badge' :src="honoraryBadge | getDisplayImageSmall"></Avatar>
                  </router-link> -->
                </i-col>
                <i-col :span="15" style="position:relative;">
                  <!-- User Data -->
                  <!-- <i-button @click="$router.push('/settings')" style="position:absolute;right:0;z-index:3;padding:4px 6px 3px" type="default" shape="circle" v-if="isCurrentUser">
                    <Icon type="edit" size="16"></Icon>
                  </i-button> -->
                  <!-- <Dropdown placement="bottom-end" style="position:absolute;right:0;z-index:3;" v-if="!isCurrentUser">
                    <span style="padding:0 5px">
                      <Icon size="20" type="android-more-vertical"></Icon>
                    </span>
                    <DropdownMenu slot="list">
                      <DropdownItem>
                        <a @click="bookmark()">{{ profile.bookmarked ? 'Remove bookmark' : 'Bookmark'}}</a>
                      </DropdownItem>
                      <DropdownItem>
                        <a @click="showReport(profile.id)">Report this user</a>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown> -->
                  <h3 style="padding-right:12px;margin:0;ine-height: 20px;" v-if="false">
                    <ellipsis
                      ref="ellipsis"
                      v-if="profile.display_name"
                      :assume-pixel="6"
                      :expandables="false"
                      :is-current-user="isCurrentUser"
                      :content="profile.display_name" />
                    <!-- {{profile.display_name}} -->
                  </h3>

                  <!-- <p v-if="!isCurrentUser && !isHonoraryLoading && honoraryBadge && this.$store.state.user.info.user_type !== 'guest'"><small>
                    <a style="font-weight:700;color:red" @click="claimProfileModal = true">Claim this profile</a>
                    </small></p> -->
                </i-col>
                <!-- Profile -->
                <i-col :span="24" style="position:relative">
                  <i-button @click="$router.push('/settings')" style="width: 36px;top:-5px;position:absolute;right:0;z-index:3;padding:4px 6px 3px" type="default" shape="circle" v-if="isCurrentUser">
                    <Icon type="edit" size="16"></Icon>
                  </i-button>
                  <div v-if="!(isAllowPoints && isCurrentUser)" style="width:200px;height:200px;margin:0 auto;overflow:hidden;position:relative">
                    <div ref="UA" style="overflow:hidden;width:100%;padding-top:100%;margin:0 auto;display:block;border-radius:10px">
                      <img class="avatar-box" @click="showVuerSingle($event,'imgViewer2',true)" v-on:load="onloadAvatar" ref="imgViewer2" :src="('avatar' in profile && profile.avatar) ? userDisplayImage(profile): profilePlaceholder" alt=" "/>
                    </div>
                  </div> 
                  <ResilienceDoughnut v-else msize="normal" mid="profile-res" :profile="profile" />
                  <h1 align="center" class="truncate">
                    <ellipsis
                      ref="ellipsis"
                      v-if="profile.display_name"
                      :assume-pixel="6"
                      :expandables="false"
                      :is-current-user="isCurrentUser"
                      :content="profile.display_name" />
                  </h1>
                  <!-- <p align="center" style="margin-top:0px;"><small>
                    <a style="font-size:12px" @click="view('followers')">{{profileFollowCount.followers || 0}} Followers</a> |
                    <a style="font-size:12px" @click="view('following')">{{profileFollowCount.following || 0}} following</a></small></p>
                  <div v-if="!isCurrentUser && profile.is_public == 1" style="display: flex; justify-content: center; padding: 10px;">
                    <view-public-profile-follow-button :followed="profile.is_followed" :userId="profile.id" type="default" size="small"/>
                  </div> -->
                </i-col>
                <!-- End -->
                <i-col :span="24" v-show="false">
                  <Row :gutter="10" type="flex" align="top" style="margin-top:10px">
                    <i-col :span="9">
                      <div style="text-align:center">
                        <span v-if="!galleryLoading" v-for="(i,k) in gallery.activity.careplan_item" :key="i.guid" style="margin-right:.13rem;height:32px;display:inline-block;vertical-align:top">
                          <span>
                            <img @click="showVuerPlaylist($event,'imgViewer',true,k)" :src="setActivityImage(i)" style="width:32px;height:32px;" width="32px" height="32px" alt=""/></span>
                            <img v-show="false" ref="imgViewer" :src="setActivityImage(i, true)" style="width:32px;height:32px;" width="100%" alt="">
                        </span>
                        <span v-if="gallery.activity" v-for="i in emptyLength" :key="i" style="margin-right:.13rem;height:32px;display:inline-block;vertical-align:top">
                          <span>
                            <Avatar @click="isCurrentUser | $router.push('/settings')" shape="square" style="border:1px dashed #ddd;width:32px;height:32px;" alt="" class="grayscale"/></span>
                        </span>
                      </div>
                    </i-col>
                    <i-col :span="15" style="position:relative" v-show="false">
                      <span @click="viewOrg()" v-if='alliance' style="position:absolute;top:-60px;margin-top:-20px;right:0">
                        <Avatar :style="{'width': (UAHeight/2)+'px', 'height': (UAHeight/2)+'px'}" style="background:#fff;border:1px solid #f2f2f2;float:right;border-radius:100%;margin-right:2px" :src="alliance | getDisplayImage"></Avatar>
                      </span>
                      <div class="social-links-style" style="text-align:right;height: 32px;">
                        <span @click='socialLink("facebook")'>
                          <Avatar :class='profile.facebook ? "colored-ui-facebook" : "grayscale"' style="margin-bottom:10px" shape="square" icon="social-facebook"></Avatar>
                        </span>
                        <span @click='socialLink("twitter")'>
                          <Avatar :class="profile.twitter ? 'colored-ui-twitter' : 'grayscale'" style="margin-bottom:10px" shape="square" icon="social-twitter"></Avatar>
                        </span>
                        <span @click='socialLink("instagram")'>
                          <Avatar :class="profile.instagram ? 'colored-ui-instagram' : 'grayscale'" style="margin-bottom:10px" shape="square" icon="social-instagram"></Avatar>
                        </span>
                        <span @click='socialLink("linkedin")'>
                          <Avatar :class="profile.linkedin ? 'colored-ui-linkedin' : 'grayscale'" style="margin-bottom:10px" shape="square" icon="social-linkedin"></Avatar>
                        </span>
                        <span @click='socialLink("website")'>
                          <Avatar :class="profile.website ? 'colored-ui-website' : 'grayscale'" style="margin-bottom:10px" shape="square" icon="ios-world"></Avatar>
                        </span>
                      </div>
                    </i-col>
                  </Row>
                </i-col>
              </Row>
              <Row :gutter="10" type="flex" align="top" v-if="profile && profileLoader">
                <i-col :span="24" style="display: flex; justify-content: center">
                  <div ref="UAA" style="background:#f2f2f2; width: 200px; height: 200px; padding-top:35%; overflow:hidden;border-radius:10px">
                    <!-- <img style="background:#f2f2f2;width:100%;height:100%" alt=" "/> -->
                    <div style="background:#f2f2f2;width:100%;height:100%"></div>
                  </div>
                </i-col>
                <i-col :span="24" style="display: flex; justify-content: center">
                  <h3 style="position:relative ;padding-top:10px" class="truncate">
                    <div style="width:100px;height:20px;background:#f2f2f2;border-radius:3px"></div>
                  </h3>
                </i-col>
                <i-col :span="12" style="display: flex; justify-content: flex-end">
                  <h3 style="position:relative ;padding-top:10px" class="truncate">
                    <div style="width:100px;height:15px;background:#f2f2f2;border-radius:3px"></div>
                  </h3>
                </i-col>
                <i-col :span="12" style="display: flex; justify-content: start">
                  <h3 style="position:relative ;padding-top:10px" class="truncate">
                    <div style="width:100px;height:15px;background:#f2f2f2;border-radius:3px"></div>
                  </h3>
                </i-col>

              </Row>
              <!-- <ContentLoading v-show="true" height="200">
                <rect x="0" y="0" rx="10" ry="10" width="36%" height="36vw" />

                <rect x="38vw" y="2px" rx="3" ry="3" width="150px" height="24px" />
                <rect x="38vw" y="30px" rx="3" ry="3" width="125px" height="15px" />

                <circle cx="89vw" cy="115px" r="8vw" />

                <rect x="6vw" y="38vw" rx="1" ry="1" width="32px" height="32px" />
                <rect x="14vw" y="38vw" rx="1" ry="1" width="32px" height="32px" />
                <rect x="22vw" y="38vw" rx="1" ry="1" width="32px" height="32px" />


                <rect x="55vw" y="38vw" rx="1" ry="1" width="32px" height="32px" />
                <rect x="63.5vw" y="38vw" rx="1" ry="1" width="32px" height="32px" />
                <rect x="72vw" y="38vw" rx="1" ry="1" width="32px" height="32px" />
                <rect x="80.5vw" y="38vw" rx="1" ry="1" width="32px" height="32px" />
                <rect x="89vw" y="38vw" rx="1" ry="1" width="32px" height="32px" />
              </ContentLoading> -->
            </Card>

            <!-- <div v-if="profile && profile.id && profile.journal_id" v-show="false"> -->
              <!-- <view-public-profile-badge-list ref="badgelist" :userId="profile.id" :journalId="profile.journal_id"/> -->
              <!-- <ViewPublicProfileBadgeList ref="badgelist" :userId="profile.id" :journalId="profile.journal_id">
              </ViewPublicProfileBadgeList>
            </div> -->

            <div style="padding:10px 10px 0" v-if="$store.state.publicProfile.info.data.about_me || isCurrentUser ">
              <Row :gutter="5" v-show="false">
                <Col :span="3" style="vertical-align: top;">
                  <Avatar :src="getAvatarSmall()" size="large" style="vertical-align: top; box-shadow: 2px 1px 10px rgba(0, 0, 0, .5);"/>
                </Col>
                <Col :span="21">
                  <about-me />
                </Col>
              </Row>
            </div>
            <ContentLoading  v-show="false && profileLoader" :height="400" style="margin:1px 5px 0px 5px;">
              <circle cx="25" cy="25" r="21" />
              <rect x="70" y="8" rx="4" ry="4" width="80%" height="60" />
              <!-- <rect x="100" y="70" rx="4" ry="4" width="60%" height="6" />
              <rect x="120" y="77" rx="4" ry="4" width="50%" height="6" />
              <rect x="140" y="84" rx="4" ry="4" width="40%" height="6" /> -->

              <!-- <rect x="10" y="100" rx="4" ry="4" width="60%" height="13" />
              <circle cx="15" cy="133" r="5" />
              <rect x="30" y="130" rx="4" ry="4" width="85%" height="8"/>
              <circle cx="15" cy="153" r="5" />
              <rect x="30" y="150" rx="4" ry="4" width="85%" height="8"/>
              <circle cx="15" cy="173" r="5" />
              <rect x="30" y="170" rx="4" ry="4" width="85%" height="8"/>

              <rect x="10" y="200" rx="4" ry="4" width="60%" height="13" />
              <circle cx="15" cy="230" r="5" />
              <rect x="30" y="230" rx="4" ry="4" width="85%" height="8"/>
              <circle cx="15" cy="250" r="5" />
              <rect x="30" y="250" rx="4" ry="4" width="85%" height="8"/>
              <circle cx="15" cy="270" r="5" />
              <rect x="30" y="270" rx="4" ry="4" width="85%" height="8"/>

              <rect x="10" y="300" rx="4" ry="4" width="60%" height="13" />
              <circle cx="15" cy="330" r="5" />
              <rect x="30" y="330" rx="4" ry="4" width="85%" height="8"/>
              <circle cx="15" cy="350" r="5" />
              <rect x="30" y="350" rx="4" ry="4" width="85%" height="8"/>
              <circle cx="15" cy="370" r="5" />
              <rect x="30" y="370" rx="4" ry="4" width="85%" height="8"/> -->
            </ContentLoading>

            <ProfileSnippet v-show="false" :countryId="country.careplan_id" :profile="profile"></ProfileSnippet>
            <MyBio v-show="false" ref="GCBio" :is-current-user="isCurrentUser" :id="profile.journal_id" :journal="profile"></MyBio>
            <div v-if="!isLoading && !profileLoader">
              <ColumnGroupCards ref="GC" :is-current-user="isCurrentUser" :id="profile.journal_id" :journal="profile" :has-bookmark="userBookmarks && userBookmarks.data && userBookmarks.data.length > 0"></ColumnGroupCards>
            </div>
            <!-- <div style="padding:10px 10px 0">
              <Card :padding="0">
                <p style="color:#aaa;padding:5px 10px">
                  <small><span v-if="isCurrentUser">My</span> Advocacies</small>
                </p>
                <CardViewGroups ref="advocacyCards" :is-current-user="isCurrentUser" :journal="profile" g-type="interest" style="margin-bottom:10px"/>
              </Card>
            </div>
            <div style="padding:10px 10px 0">
              <Card :padding="0">
                <p style="color:#aaa;padding:5px 10px">
                  <small><span v-if="isCurrentUser">My</span> Organizations</small>
                </p>
                <CardViewGroups ref="organizationCards" :is-current-user="isCurrentUser" :journal="profile" g-type="alliance" style="margin-bottom:10px"/>
              </Card>
            </div>
            <div style="padding:10px 10px 0">
              <Card :padding="0">
                <p style="color:#aaa;padding:5px 10px">
                  <small><span v-if="isCurrentUser">My</span> Events</small>
                </p>
                <CardViewGroups ref="eventCards" :is-current-user="isCurrentUser" :journal="profile" g-type="event" style="margin-bottom:10px"/>
              </Card>
            </div>
            <div style="padding:10px 10px 0" v-if="isCurrentUser">
              <Card :padding="0">
                <p style="color:#aaa;padding:5px 10px">
                  <small>Others</small>
                </p>
                <CardViewGroups ref="othersCards" :is-current-user="isCurrentUser" :journal="profile" g-type="public" style="margin-bottom:10px"/>
              </Card>
            </div> -->
            <!-- <br/> -->
            <!-- <Card shadow :padding="10">
              <div class="profile-menu" @click="view('bookmarks')">
                <Avatar icon="android-bookmark" :style="{background: '#333',width: '35px', height: '35px'}" shape="square">
                  </Avatar> &nbsp; <b><span v-if="isCurrentUser">My</span> Bookmarks</b></div>
            </Card> -->
            <!-- <div v-if="userBookmarks.data.length > 0">
              <div :padding="0">
              <div style="margin-bottom: 5px;padding-left: 10px;padding-right: 7.5px;">
                <p style="color:red; margin-bottom: 10px;"><b>{{bookmarkLabel}}</b></p>
              </div>
                <CardViewBookmarks style="margin-bottom:10px"/>
              </div>
            </div> -->
            <!-- <ProfileSnippet :profile="profile"></ProfileSnippet> -->
          </TabPane>
          <TabPane v-if="!isBroadcast" :label="labelTimeline" name="timeline" :disabled="!profile || !('careplan_id' in profile) || profileLoader">
            <Card v-if="!profileLoader" class="profile-holder" shadow :style="{marginBottom: isBroadcast ? '10px !important' : '0px'}">
              <div style="display: flex;">
                <div style="">
                  <div style="overflow:hidden;height: 60px;width:60px;border-radius:10px; margin-right: 10px;">
                    <img :src="('avatar' in profile && profile.avatar) ? userDisplayImage(profile): profilePlaceholder" width="100%" height="100%" style="width:100%;height:100%" alt=" "/>
                  </div>
                </div>
                <div style="margin-left: 4px;">
                  <Dropdown placement="bottom-end" style="position:absolute;right:0;z-index:3;" v-if="!isCurrentUser">
                    <span style="padding:0 5px">
                      <Icon size="20" type="android-more-vertical"></Icon>
                    </span>
                    <DropdownMenu slot="list">
                      <DropdownItem>
                        <a @click="bookmark()">{{ profile.bookmarked ? 'Remove bookmark' : 'Bookmark'}}</a>
                      </DropdownItem>
                      <DropdownItem>
                        <a @click="showReport(profile.id)">Report this user</a>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                  <h3 style="padding-right:10px" class="truncate">
                    {{profile.display_name}}
                  </h3>
                </div>
              </div>
            </Card>
            <PostActivity text-area-placeholder="Post something to your timeline..." v-if="!isBroadcast && isCurrentUser" view="journal-public" style="margin-top: 10px;" :page-data="profileInfo"></PostActivity>
            <!-- <Tabs  v-if="isCurrentUser" class="post-type-tab" type="line" size="small" :animated="false">
              <TabPane label="Public">
              </TabPane>
              <TabPane label="Private">
                <FeedListPublic section="journal" :isPublic="false"/>
              </TabPane>
            </Tabs> -->

            <FeedListPublic :style="{marginTop: isCurrentUser ? '0px' : '10px'}" section="journal" :isPublic="true"/>
          </TabPane>
          <TabPane v-if="!isBroadcast" :label="isCurrentUser ? 'My Team' : 'Team'" name="team" :disabled="profileLoader">
          </TabPane>
        </Tabs>
        <div v-if="tabName == 'team'  && !isLoading" >
          <Card class="profile-holder" shadow style="margin-bottom:10px">
            <div style="width:100%;display:flex">
              <div style="width:60px;height:60px;margin-right: 10px;">
                <img :src="('avatar' in profile && profile.avatar) ? userDisplayImage(profile): profilePlaceholder" style="border-radius:10px;width:60px;height:60px"/>
              </div>
              <div style="width: 100%; margin-left: 4px;">
                 <h3 style="padding-right:10px; width: 100%" class="truncate">
                  {{profile.display_name}}
                  <span class="pointer" @click="openHelp()" style="color:#aaa; float: right;">
                    <!-- Care Team -->
                    <i class="fa fa-info-circle" />
                  </span>
                </h3>
                <CareTeam v-if="!isLoading && profile.private_careplan_id" :user="profile" :isCurrentUser="isCurrentUser" />
              </div>
            </div>
          </Card>
          <div v-if="tabName == 'team' && !profileLoader && !privateCareplan.isLoading && !isLoading && !privateCareplan.data.subscribed">
            <h2 align="center" style="color:#aaa;margin-top:10vh">
              You're not a member of {{profile.display_name}}'s<br/>Care Team.
              <br/><br/>
              <Button :loading="requestToJoinCareteamLoading" @click="requestToJoinCareteam()">Request</Button>
            </h2>
          </div>
          <div v-else-if="tabName == 'team' && privateCareplan.data.subscribed">
            <div style="padding: 7px 0px; display: flex; justify-content: space-between;">
              <Button @click="postPrivate" class="post-button">
                Post
              </Button>
              <Button @click="postPrivateDocument" class="upload-button">
                Upload Document
              </Button>
            </div>
            <!-- <PostActivity view="journal-private" style="margin-top:10px;margin-bottom:10px" :page-data="profileInfo"></PostActivity> -->
            <!-- <RadioGroup v-if="false" v-model="privateFilter" style="margin: 10px; padding: 2px;">
              <Radio
                label="all"
              >All</Radio>
              <Radio
                label="post"
              >Post</Radio>
              <Radio
                label="document"
              >Document</Radio>
              <Radio
                label="checkin"
              >Check-in</Radio>
            </RadioGroup> -->
            <FeedListPublic section="journal" :isPublic="false"/>
          </div>
        </div>
      </div>
      <ReportUser :itemtype="'user'" :userid="userid" ></ReportUser>

      <!-- <Modal
        v-model="claimProfileStep1"
        title="Claim Profile"
        class-name="claimProfile"
        :mask-closable="false"
        :closable="false">
        <div slot="header">
          <div style="height:35px;color:#fff">
            <img alt=" " @click="claimProfileStep1=false" style="height:25px; width:25px;position:absolute;top:0;right:0;margin:5px 10px 0 0;" src="@/assets/close.png">
          </div>
        </div>
        <div v-if="true">
          <div class="hero-holder" style="margin:8px">
            <div style="display:flex;-webkit-box-align: center;align-items: center;">
              <div style="height:auto;margin:0px 8px">
                <img :src='claimProfile' style="height:120px;width:160px;"/>
              </div>
              <div style="width:100%;">
                <h1 align="center">Claim this<br> Profile</h1>
                <div style="color:rgb(170, 170, 170);font-size: 20px" align="center">(Step 1)</div>
              </div>
            </div>
            <div style="font-size: 2.25vh;text-align:center;padding:20px 8px">
              <p>Sharpen Founder has created temporary profiles for a select group of accomplished or distinguished personages in the Philippines.</p>
              <p style="margin-top: 10px;">To claim this profile for the personality involved, please tap the
                <span style="font-weight: bold;;color:#2d8cf0">Next</span>
                buton and complete the simple form. A member of the TM staff will follow-up for verification and transfer of the  control of this profile. </p>
            </div>
          </div>
        </div>
        <div slot="footer">
          <Button @click="claimProfileStep1 = false" type="text">Cancel</Button>
          <Button @click="step1Next" type="primary">Next</Button>
        </div>
      </Modal>       -->
      <ModalHolder
        title=""
        m-top="120"
        :class-name="'help-modal'"
        :is-show="help.showHelpModal">
        <template slot="mheader">
          <div style="height: 20px;">
            <span style="position:absolute;right:15px;top:15px" @click="help.showHelpModal=false">
              <Icon size="20" type="close-circled"></Icon>
            </span>
          </div>
        </template>
        <template slot="mcontent">
          <div class="help-holder" style="height: 100%; justify-content: center">
            <p v-if="help.isLoading" align="center" style="padding:5px">
              <i class="fa fa-spin fa-spinner" /> Loading...
            </p>
            <span v-else>
              <p v-if="help.info_item && help.info_item.data" v-html="help.info_item.data.tip"></p>
            </span>
          </div>
        </template>
      </ModalHolder>

      <Modal
        v-model="claimProfileModal"
        title="Claim Profile"
        class-name="claimProfile"
        :mask-closable="false"
        :closable="false">
        <div slot="header">
          <div style="height:35px;color:#fff">
            <img alt=" " @click="closeClaimProfileModal" style="height:25px; width:25px;position:absolute;top:0;right:0;margin:5px 10px 0 0;" src="@/assets/close.png">
          </div>
        </div>
        <div v-if="claimProfileStep1">
          <div class="hero-holder" style="margin:8px">
            <div style="display:flex;-webkit-box-align: center;align-items: center;">
              <div style="height:auto;margin:0px 8px">
                <img :src='claimProfile' style="height:120px;width:160px;"/>
              </div>
              <div style="width:100%;">
                <h1 align="center">Claim this<br> Profile</h1>
                <div style="color:rgb(170, 170, 170);font-size: 20px" align="center">(Step 1)</div>
              </div>
            </div>
            <div style="font-size: 2.25vh;text-align:center;padding:20px 8px">
              <p>Sharpen Founder has created temporary profiles for a select group of accomplished or distinguished personages in the Philippines.</p>
              <p style="margin-top: 10px;">To claim this profile for the personality involved, please tap the
                <span style="font-weight: bold;;color:#2d8cf0">Next</span>
                buton and complete the simple form. A member of the Sharpen staff will follow-up for verification and transfer of the  control of this profile. </p>
            </div>
          </div>
        </div>
        <div v-if="!claimProfileStep1">
          <div class="hero-holder" style="margin:8px">
            <div style="display:flex;-webkit-box-align:">
              <div style="height:auto;margin:0px 8px">
                <img :src='claimProfile' style="height:80px;width:100px;"/>
              </div>
              <div style="width:100%;">
                <h1 align="center">Claim this Profile</h1>
                <div v-if="!isStep3" style="color:#aaaaaa;font-size: 20px" align="center">(Step 2)</div>
                <div v-if="isStep3" style="color:#aaaaaa;font-size: 20px" align="center">(Step 3)</div>
              </div>
            </div>
            <Spin v-if="claimLoading" fix>
              <Icon type="load-c" class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
            <div v-if="isStep3" style="font-weight: bold;font-size: 3.5vh;text-align:center;padding:20px 8px">
              <p>Thank you.</p>
              <p style="margin-top: 10px;">Your claim has been received. We will follow-up on this request.</p>
            </div>
            <div v-if="!isStep3">
                <div style="padding: 10px;">
                  <div style="display:-webkit-box;border-bottom: 1px solid #aaaaaa;padding: 10px;">
                    <Avatar :src="getCurrentUserAvatarSmall()" size="large" style="margin-right:10px;vertical-align: top; box-shadow: 2px 1px 10px rgba(0, 0, 0, .5);"/>
                    <div style="font-size: 2.25vh;font-weight: bold;">
                      <span>Hi, {{currentUser.display_name}}</span>
                      <div>Please select an option.</div>
                    </div>
                  </div>
                </div>
                <div style="margin: 10px 20px">
                  <RadioGroup v-model="claimStatus" vertical>
                    <Radio style="height:auto;line-height:1.5" label="myself"><span style="height:auto;display: inline-flex;white-space: normal;font-size: 2.25vh">I am claiming this profile for myself. </span> </Radio>
                    <Radio style="height:auto;margin-top: 10px;line-height:1.5"  label="someone-else"><span style="height:auto;display: inline-flex;white-space: normal;font-size: 2.25vh">I have permission to claim this profile for someone else. (i.e Staff, family or friend)</span></Radio>
                  </RadioGroup>
                </div>
                <div style="font-size: 2.25vh;text-align:center;margin:20px 8px;color:#aaaaaa;">
                  <p>Someone from the Sharpen Staff will follow up for verification at: <span style="font-weight: bold;;color:red">{{currentUser.contact_number}}</span></p>
                </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div v-if="!isStep3 && !claimProfileStep1">
            <Button @click="closeClaimProfileModal" type="text">Cancel</Button>
            <Button @click="postClaimProfile" type="primary">Submit</Button>
          </div>
          <Button v-if="isStep3 && !claimProfileStep1" @click="closeClaimProfileModal" type="primary">Close</Button>
          <div v-if="claimProfileStep1">
            <Button @click="closeClaimProfileModal" type="text">Cancel</Button>
            <Button @click="step1Next" type="primary">Next</Button>
          </div>
        </div>
      </Modal>

  </app-layout>
</template>

<script>

import PublicFeedList from "@/components/PublicFeedListComponent";
import ReportUser from '@/components/ReportComponent';
import ResourceListItemPublicComponent from "@/components/ResourceListItemPublicComponent";
import Utils from '@/utils.js'
import VuerMixin from '@/helpers/vuerMixin'
import FeedList from "@/components/FeedListComponent";
import FeedListPublic from "@/components/FeedListPublicComponent";
import PostActivity from "@/components/PostActivityComponent";
import ResourceListItemComponent from "@/components/ResourceListItemComponent";
import ViewPublicProfileBadgeList from '@/components/ViewPublicProfileBadgeList';
import ViewPublicProfileFollowButton from '@/components/ViewPublicProfileFollowButton'
import ColumnGroupCards from '@/components/ColumnGroupCards'
import MyBio from '@/components/MyBio'
import CardViewGroups from '@/components/CardViewGroups'
import ViewPublicProfileAbout from '@/views/ViewPublicProfileAbout'
import ProfileSnippet from '@/components/ProfileSnippet'
import Cons from "@/constants.json";
import CardViewBookmarks from "@/components/CardViewBookmarks";
import AboutMe from './ViewPublicProfileAboutMe'
import ContentLoading from 'vue-content-loading';
import CareTeam from '@/components/CareTeam';
import ModalHolder from "@/components/ModalHolderComponent";
import ResilienceDoughnut from "@/components/ResilienceDoughnut";
import { Message } from 'iview'
import { mapGetters } from 'vuex'

export default {
  name: 'ViewPublicProfileComponent',
  components: {
    PublicFeedList, ReportUser, FeedList, PostActivity, ResourceListItemComponent,
    FeedListPublic, ResourceListItemPublicComponent,ViewPublicProfileBadgeList,
    ViewPublicProfileFollowButton, ColumnGroupCards, MyBio,
    ViewPublicProfileAbout,CardViewGroups, ProfileSnippet, CardViewBookmarks,
    AboutMe, ContentLoading, CareTeam, ModalHolder, ResilienceDoughnut
  },
  created() {

  },
  mounted() {
    if ( !('tab' in this.$route.query ) )
      this.$router.replace({query: {tab: 'me'}})

    this.tabName = ( this.$route.query.tab ) ? this.$route.query.tab : 'me'

    if (this.$refs['UA'] !== undefined) {
      this.UAHeight = this.$refs['UA'].width || 'auto';
    }

    this.init()
  },
  data () {
    return {
      help: {
        isLoading: false,
        info_item: null,
        showHelpModal: false,
      },
      privateFilter: 'all',
      offsetNo: 85,
      stickTabs: false,
      UAHeight: 'auto',
      UAWidth: 'auto',
      profilePlaceholder: require('@/assets/person-placeholder.png'),
      userid: '',
      groupID: Cons[0].GROUP_ID,
      labelTimeline: (h) => {
        return h('div', [
            h('span', 'Timeline '),
        ])
      },
      labelMe: (h)=> {
        return h('div', [
          h('span', this.isCurrentUser? ' Profile ': ' Profile '),
        ]);
      },
      form: Cons[0].ACTIVITY,
      claimProfileModal: false,
      claimProfileStep1: true,
      claimProfileStep2: false,
      claimLoading: false,
      isStep3: false,
      claimStatus: 'myself',
      privateCareplan: {
        data: {},
        isLoading: {}
      },
      requestToJoinCareteamLoading: false
    }
  },
  watch: {
    // $route: {
    //   handler: 'init',
    //   immediate: true
    // },
    privateFilter(n) {
      this.myPrivateTimeline(this.profile)
    },
    profileUid(n) {
      this.init()
    }
  },
  mixins:[VuerMixin],
  methods: {
    requestToJoinCareteam() {
      this.requestToJoinCareteamLoading = true

      var payload = {
        private_careplan_id: this.profile.private_careplan_id,
        journal_id: this.$store.state.user.info.journal_id
      }

      this.$store.dispatch('publicProfile/requestToJoinCareteam', payload)
        .then(res => {
          this.$Message({
            closable: true,
            durationInSec: 3,
            title: { content: "Success" },
            message: { content: "Request Sent" }
          });
        })
        .finally(() => {
          this.requestToJoinCareteamLoading = false
        })
    },
    openHelp() {
      this.help.isLoading = true
      this.$store.dispatch('user/getActivityInfo', Cons[0].HELP_ID.careTeam[process.env.VUE_APP_DEV_STATUS])
        .then(res => {
          this.help.isLoading = false
          this.help.info_item = res
        })
        .catch(err => {
          this.help.isLoading = false
        })
      this.help.showHelpModal = true
    },
    postPrivate() {
      this.$router.replace({
          query: {
            post: this.$store.state.publicProfile.info.data.private_careplan_id,
            action: 'post',
            tab: 'team',
            from: 'journal-private',
            is_document: false,
            is_public: false,
            filter: this.privateFilter
          }
        })

      this.$store.commit('publicModule/setShowPostItemModal', true)
    },
    postPrivateDocument() {
      this.$router.replace({
        query: {
          post: this.$store.state.publicProfile.info.data.private_careplan_id,
          action: 'post',
          tab: 'team',
          from: 'journal-private',
          is_document: true,
          is_public: false,
          filter: this.privateFilter
        }
      })

      this.$store.commit('publicModule/setShowPostItemModal', true)
    },
    closeClaimProfileModal(){
      this.claimProfileModal = false,
      setTimeout(() => {
        this.claimStatus= 'myself',
        this.claimProfileStep2 = false,
        this.isStep3 = false,
        this.claimProfileStep1 = true
      }, 300);
    },
    step1Next(){
      this.claimProfileStep1 = false;
      this.claimProfileStep2 = true;
    },
    getAvatarSmall() {
      const url = Utils.getDisplayImage('user', this.$store.state.publicProfile.info.data, 'small');
      return url;
    },
    getCurrentUserAvatarSmall() {
      const url = Utils.getDisplayImage('user', this.$store.state.user.info, 'small');
      return url;
    },
    onloadAvatar() {
      let obj = this.$refs['imgViewer2'];
      if (obj !== undefined) {
        this.UAWidth = this.$refs['imgViewer2'].width
        this.UAHeight = this.$refs['imgViewer2'].width
      }
    },
    init() {
      // let isSameUser = this.$store.state.publicProfile.info.previousUserId == this.$route.params.uid;

      if (this.$store.state.user.info && this.$store.state.user.info.user_type === 'guest') {
        this.$store.commit('hitCheckpoint')
        this.$router.replace('/home')
        return false
      }

      // if( !isSameUser ) {
        this.loadData()
      // }
    },
    loadData() {
      this.$store.commit('gallery/setGalleryLoader', true);
      if(this.profile.id && this.$store.state.publicProfile.info.isLoading) return false

      this.$store.dispatch('publicProfile/getUserInfo', this.$route.params.uid).then(
        res=> {
          if (res.user_type === 'guest') {
            this.$store.commit('hitCheckpoint')
            this.$router.go(-1)
            return false;
          }
          
          if (this.isBroadcast && !this.isCurrentUser){
            Message.info({
              content: 'Unable to display user profile',
              duration: 3
            });
            this.$router.go(-1)
            return
          }
          
          if (!this.isCurrentUser && this.$store.state.publicProfile.info.data.is_public == 0){
            Message.info({
              content: 'Profile is not public',
              duration: 3
            });
            this.$router.replace('/home')
            return
          }

          this.$store.dispatch('publicProfile/getHonorary', {id: res.id})
          this.$store.dispatch('publicProfile/getUserOrg', {id: res.primary_org})
          this.$store.dispatch('publicProfile/getUserFollowCount', {id: res.id})
          this.$store.dispatch('publicProfile/getCountry', {journalId: res.journal_id});
          this.$store.dispatch('gallery/getUserGallery', {id: res.careplan_id})
          this.$store.dispatch('user/getUserBookmarks', {id: res.id})
          this.$refs['GC'].loadGroups();
          this.$refs['GCBio'].loadGroups();

          // this.$refs['advocacyCards'].loadGroups();
          // this.$refs['organizationCards'].loadGroups();
          // this.$refs['eventCards'].loadGroups();
          // this.$refs['othersCards'].loadGroups();
          this.myTimeline(this.profile);
          this.myPrivateTimeline(this.profile)
          this.loadMyPrivateCareplan(this.profile)
        }
      );
    },
    viewOrg() {
      this.$router.push('/resources/' + this.alliance.id)
    },
    alertComingSoon() {
      this.$Message({
        closable: true,
        title: { content:'Coming Soon!' },
        icon: 'alert',
        message: { content: 'This feature is under construction.' },
        buttons: [
          { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> {} }
        ]
      });
    },
    view(v) {
      if(v == 'followers' || v == 'following') {
        this.$store.commit('follow/show', {userId: this.profile.id, type: v})
        return false
      }
      this.$router.push('/profile/' + this.$route.params.uid + '/view?section=' + v);
    },
    change(status) {
      this.stickTabs = status;
    },
    showReport: function(userid) {
      if (this.$store.state.user.info && this.$store.state.user.info.user_type === 'guest') {
        this.$store.commit('hitCheckpoint')
        return false
      }

      this.userid=userid;
      this.$store.commit('user/setReportThisId', userid);
      this.$store.commit('user/setShowStepsUser', true);
    },
    bookmark () {
      if (this.$store.state.user.info && this.$store.state.user.info.user_type === 'guest') {
        this.$store.commit('hitCheckpoint')
        return false
      }
      // this.$store.dispatch('user/setPublicProfileBookmark')
      this.$store.dispatch('publicProfile/bookmark');
    },
    myProfileMe() {
      this.$store.dispatch('publicProfile/getMyStuff', this.$store.state.publicProfile.info.data.journal_id);
    },
    myTimeline(profile) {
      this.$store.dispatch('publicProfile/getMyTimeline', profile);
    },
    myPrivateTimeline(profile) {
      console.log('getMyPrivateTimeline', profile)
      this.$store.dispatch('publicProfile/getMyPrivateTimeline', {
        user: profile,
        filter: this.privateFilter
      })
    },
    loadMyPrivateCareplan(profile){
      this.privateCareplan.isLoading = true
      this.$store.dispatch('publicProfile/getMyPrivateCareplan', profile.private_careplan_id)
        .then(res => {
          this.privateCareplan.data = res
        })
        .finally(() => {
          this.privateCareplan.isLoading = false
        })
    },
    onTabClick(v) {
      this.tabName = v
      this.$router.replace({query: {tab: v}})
      if (v=="me") {
        this.myProfileMe();
      } else if (v=="timeline") {
        this.myTimeline(this.profile);
      }
      else if (v=='team'){
        this.myPrivateTimeline(this.profile)
      }
    },
    route(badge) {
      if( badge.type === 'badge')
        return '/resources/' + badge.id + '?tab=followers&r-type=badge'
      return '/resources/' + badge.id + '?tab=posts'
    },
    setActivityImage(act, isOrigin) {
      if( isOrigin )
        return Utils.getDisplayImage('activity', act, 'original')
      return Utils.getDisplayImage('activity', act, 'small')
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage('user', user, 'medium')
    },
    isValidUrl(url) {
      return Utils.validUrl(url)
    },
    socialLink(type) {
      console.log('socialLink...', type);
      if( !this.profile[type] ) return false;

      if (this.profile[type] && Utils.validUrl(this.profile[type])) {
        // return this.profile[type] ? this.profile[type] : ''
        window.open(this.profile[type], '_blank')
      } else {
        console.log('else...', this.profile[type]);
        switch(type) {
          case 'facebook':
            window.open('https://www.facebook.com/' + this.profile[type], '_blank')
            break;
          case 'twitter':
            window.open('https://www.twitter.com/' + this.profile[type], '_blank')
            break;
          case 'linkedin':
            window.open('https://www.linkedin.com/' + this.profile[type], '_blank')
            break;
          case 'instagram':
            window.open('https://www.instagram.com/' + this.profile[type], '_blank')
            break;
          case 'website':
            window.open(this.profile[type],'_blank');
            break;
        }
      }
    },
    postClaimProfile(){
      this.claimLoading = true

      this.form.recurrence = [Utils.setRrulePostDate(new Date())];
      this.form.data_type = "content";
      this.form.type = "claim_profile";
      this.form.title = "Claim Profile";
      this.form.is_published = 1
      this.form.data = {}
      this.form.data.claim_status = this.claimStatus
      this.form.data.claimer_id = this.currentUser.id
      this.form.data.claim_id = this.profile.id
      this.form.data.claim_user = this.profile
      this.form.show_dashboard = false

      this.$store.dispatch("feed/postCareplanUpdate", {
          id: Cons[0].GROUP_ID.claimProfileId,
          data: this.form
        })
        .then(res => {
          this.claimLoading = false
          this.isStep3 = true
        },error =>{
          this.claimLoading = false
          this.isStep3 = false
        });
    }
  },
  filters: {
    getDisplayImage(data) {
      return Utils.getDisplayImage('group', data, 'medium')
    },
    getDisplayImageSmall(data) {
      return Utils.getDisplayImage('group', data, 'small')
    },
    getCountryImage(data) {
      return Utils.getDisplayImage('group', data.careplan, 'small')
    }
  },
  computed: {
    ...mapGetters("user", ["isAllowPoints", "isBroadcast"]),
    closeIcon: {
      get() {
        return require('@/assets/close.png')
      }
    },
    claimProfile: {
        get() {
          return require('@/assets/resources/Claim_profile_art.jpg')
        }
    },
    isHonoraryLoading() {
      return this.$store.state.publicProfile.isHonoraryLoading;
    },
    isHonorary() {
      return this.$store.state.publicProfile.honorary && this.$store.state.publicProfile.honorary.length >= 1
      // return true
    },
    honoraryBadge() {
      if(this.$store.state.publicProfile.honorary && this.$store.state.publicProfile.honorary.length == 0){
        return [];
      }else if(!this.$store.state.publicProfile.honorary){
        return [];
      }
      return this.$store.state.publicProfile.honorary[0]
    },
    badger() {
      return this.$store.state.publicProfile.myBadges.data
    },
    tabName: {
      get() {
        return this.$route.query.tab || 'me'
      },
      set(v) {
        return v;
      }
    },
    emptyLength: {
      get() {
        if(this.galleryLoading) return 3

        if( this.gallery.activity.total < 3)
          return 3 - this.gallery.activity.total
        return 0
      }
    },
    gallery: {
      get() {
        return this.$store.state.gallery.data
      }
    },
    galleryLoading() {
      return this.gallery.isLoading
    },
    pencil: {
      get() {
        return require('@/assets/pencil.png')
      }
    },
    isCurrentUser: {
      get() {
        return this.$store.state.user.info.id == this.$store.state.publicProfile.info.data.id;
      }
    },
    currentUser: {
      get() {
        return this.$store.state.user.info;
      }
    },
    bookmarkLabel: {
      get() {
        return (this.isCurrentUser) ? "MY BOOKMARKS" : "BOOKMARKS"
      }
    },
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    countUserStuffs: function() {
      return this.$store.state.user.countUserStuffs;
    },
    countTimeline: function() {
      return this.$store.state.user.countFeedList;
    },
    userIdCurrent: function() {
      return this.$store.state.user.info.id;
    },
    userIdPublic: function() {
      return this.$store.state.user.publicProfile.id;
    },
    isLoading: {
      get() {
        return this.$store.state.user.journalFeed.isLoading;
      }
    },
    alliance: {
      get () {
        return this.$store.state.publicProfile.info.alliance;
      }, set(v) {
        this.$store.state.publicProfile.info.alliance = v;
      }
    },
    profile: {
      get () {
        if( this.isCurrentUser )
          return this.profileInfo
        return this.$store.state.publicProfile.info.data;
      }
    },
    profileFollowCount: {
      get () {
        return this.$store.state.publicProfile.info.followCount;
      }
    },
    profileLoader: {
      get () {
        return this.$store.state.publicProfile.info.isLoading;
      }
    },
    fbUrl: {
      get () {
        if ('fb_link' in this.$store.state.user.publicProfile && this.$store.state.user.publicProfile.fb_link) { return 'https://www.facebook.com/' + this.$store.state.user.publicProfile.fb_link } else if ('fb_id' in this.$store.state.user.publicProfile && this.$store.state.user.publicProfile.fb_id) { return 'https://www.facebook.com/' + this.$store.state.user.publicProfile.fb_id } else { return null }
      }
    },
    isLoadingBookmark: {
      get () {
        return this.$store.state.user.isLoadingBookmark
      }
    },
    bookmarked: {
      get () {
        // return this.$store.state.user.publicProfile.bookmarked
        return this.$store.state.publicProfile.info.data.bookmarked;
      }
    },
    getActivity: function() {
      return this.$store.state.user.journalFeed.list;
    },
    country: {
      get() {
        return this.$store.state.publicProfile.info.country;
      }
    },
    userBookmarks: {
      get () {
        return this.$store.state.user.userBookmarks
      }
    },
    profileUid() {
      return this.$route.params.uid
    }
  }
}
</script>
